import { useCallback } from 'react';
import { getApprovalRelationsUrl } from '@/constant/approval';
import { AddRelationDocument, DeleteRelationRequest } from '@/types/approval';
import { deleteDataFetcher, postDataFetcher } from '@/utils/apis';

const useRelatedApprovalMutations = () => {
  const addRelations = useCallback(
    (documentId: string, documents: AddRelationDocument[]) =>
      postDataFetcher(getApprovalRelationsUrl(documentId), { documents }),
    [],
  );

  const deleteRelations = useCallback(
    (documentId: string, relationDocumentIds: string[]) =>
      deleteDataFetcher<DeleteRelationRequest>(
        getApprovalRelationsUrl(documentId),
        { relationDocumentIds },
      ),
    [],
  );

  return { addRelations, deleteRelations };
};

export default useRelatedApprovalMutations;
